import React from 'react';
import Alert from './common/Alert';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // TODO: Send error to monitoring service (Sentry, etc.)
    // logErrorToService(error, errorInfo);
  }

  resetError = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="max-w-md w-full">
            <Alert 
              type="error"
              message="حدث خطأ ما. يرجى المحاولة مرة أخرى."
              dismissible={false}
            />
            
            {/* Error Details (show in development) */}
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="mt-6 p-4 bg-gray-100 rounded-lg border border-gray-300">
                <h3 className="text-sm font-bold text-gray-900 mb-2">تفاصيل الخطأ:</h3>
                <pre className="text-xs text-gray-700 overflow-auto max-h-48">
                  {this.state.error.toString()}
                </pre>
                {this.state.errorInfo && (
                  <>
                    <h3 className="text-sm font-bold text-gray-900 mt-4 mb-2">Stack Trace:</h3>
                    <pre className="text-xs text-gray-700 overflow-auto max-h-48">
                      {this.state.errorInfo.componentStack}
                    </pre>
                  </>
                )}
              </div>
            )}

            {/* Reset Button */}
            <div className="mt-6 flex gap-3">
              <button
                onClick={this.resetError}
                className="flex-1 px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg font-medium transition-colors"
              >
                إعادة محاولة
              </button>
              <button
                onClick={() => window.location.href = '/'}
                className="flex-1 px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-900 rounded-lg font-medium transition-colors"
              >
                الصفحة الرئيسية
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
